import ForeignLeaseIncomesError from './ForeignLeaseIncomesError';

export default ForeignLeaseIncomesError;
